import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography
} from '@mui/material';
import { styled } from "@mui/material/styles";
var _ = require('lodash');

const StyledContainer = styled(Container)`
  max-width: 600px;
  margin-top: 150px;
    `;

const StyledTypography = styled(Typography)`
color: ${({ theme }) => theme.palette.primary.contrastText};
font-weight: bold;
`;
const StyledBox = styled(Box)`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;

  `;

const NoData = ({ message, imageName }) => {

  const gifsFolder = '/static/images/animations';
  const [gif, setGif] = useState(0)

  useEffect(() => {
    setGif(`${gifsFolder}/pet${_.random(1, 4)}.gif`)
  }, [])



  return (
    <StyledBox
    >
      <StyledContainer maxWidth="md">
        <StyledTypography
          align="center"
          color="textPrimary"
          variant="subtitle2"
        >
          {message ? `${message}` : `No data found.`}
        </StyledTypography>
        <Box sx={{ textAlign: 'center' }}>
          <img
            alt="No data available yet."
            src={imageName ? imageName : gif}
            style={{
              marginTop: 20,
              display: 'inline-block',
              width: '70%',
              height: '70%',
              maxWidth: '100%',
            }}
          />
        </Box>
      </StyledContainer>
    </StyledBox>
  )
};

export default NoData;
